import { render, staticRenderFns } from "./fieldMsgList.vue?vue&type=template&id=bbb309e2&scoped=true"
import script from "./fieldMsgList.vue?vue&type=script&lang=js"
export * from "./fieldMsgList.vue?vue&type=script&lang=js"
import style0 from "./fieldMsgList.vue?vue&type=style&index=0&id=bbb309e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb309e2",
  null
  
)

export default component.exports